import { getInboundRouteService } from "@ntconnect/framework/pbx";

export const fetchInboundRoutes = (domain, page, pageSize, search) =>
  getInboundRouteService().fetchInboundRoutes(domain, page, pageSize, search);

export const createInboundRoute = (domain, params) =>
  getInboundRouteService().createInboundRoute(domain, params);

export const updateInboundRoute = (domain, params, id) =>
  getInboundRouteService().updateInboundRoute(domain, params, id);

export const deleteInboundRoute = (domain, id) =>
  getInboundRouteService().deleteInboundRoute(domain, id);
